import {
    apiRequest,
    dokumenpelantikanCreate,
    dokumenpelantikanListPegawai,
    ListJabatan,
    // masterCategories
} from "../../../../../services/adapters/kepegawaian/dokumenPelantikanService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", dokumenpelantikanCreate, {
            body: query
        }, true)
    }

    fetchPegawai = async (query) => {
        return await apiRequest("get", dokumenpelantikanListPegawai, {
            body: query
        }, true)
    }

    fetchPegawai = async (query) => {
        return await apiRequest("get", dokumenpelantikanListPegawai, {
            body: query
        }, true)
    }
    fetchListJabatan = async (query) => {
        return await apiRequest("get", ListJabatan, {
            body: query
        }, true)
    }
}

export default CreateRepository